export enum ButtonActionsEnum {
    Edit = 'EDIT',
    Delete = 'DELETE',
    Deactivate = 'DEACTIVATE',
    Duplicate = 'DUPLICATE',
    Consent = 'START_CONSENT',
    Reinvite = 'REINVITE',
    Rename = 'RENAME'
}
